
import FaqStructuredData from '@/components/FaqStructuredData.vue'

export default {
  name: 'FaqList',
  components: {
    FaqStructuredData,
  },
  props: {
    questions: Array,
  },
  data() {
    return {
      isOpen: {},
    }
  },
  methods: {
    toggleQuestion(id) {
      this.$set(this.isOpen, id, !this.isOpen[id])
    },
  },
}
